import { lazy, Suspense } from "react";

const Net = lazy(() => import("./NodeNetwork"));

export const LazyNetwork = (props) => (
  <Suspense fallback={null}>
    <Net {...props} />
  </Suspense>
);
